var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conversation"},[_c('send-message',{attrs:{"messages":_vm.messages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }